var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container small"},[(_vm.loaded)?_c('line-chart',{attrs:{"chart-data":_vm.chartdata,"chart-options":_vm.options}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }